export default __webpack_public_path__ + "static/img5@2x-13cb1fad388bfeb15366b4af914c3427.jpg";